import React, { useState, useEffect } from 'react';
import CloseButton from '../../../sharecomponents/CloseButton';
import v from '../../../../utils/Verifiers';
import { dateFormatConDiaShort } from '../../../../utils/DateFunctions';

const TablaRegistrosProyeccion = (p) => {
    const data = p.data ?? [];

    return (
        <div className='col-lg-12 p-2 blur-xl bg-white5' style={{ overflow: "auto", zIndex: 1000, position: "fixed", top: 0, left: 0, height: "100%", minHeight: "100vh" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-lg-12 p-1 mb-3 text-end'>
                    <CloseButton close={p.close} />
                </div>
                <div className='col-lg-12 p-2'>
                    <table className='table table-sm table-striped table-hover'>
                        <thead>
                            <tr>
                                <th scope='col'>Bloque</th>
                                <th scope='col'>fechas plan</th>
                                <th scope='col'>fechas proyección</th>
                                <th scope='col'>GD acumulados</th>
                                <th scope='col'>GD necesarios</th>
                                <th scope='col'>GD Faltantes</th>
                                <th scope='col'>dias diferencia</th>
                                <th scope='col'>Extemporaneo</th>
                                <th scope='col'>Rango referencia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    <th scope='row'>{row.bloque}</th>
                                    <td>{row.semana_cosecha}-{row.dia_cosecha}: {dateFormatConDiaShort(row.fecha_cosecha)}</td>
                                    <td>
                                        {row.fuente === "PROYECCION CONTEOS" ? `${row.semana_proyeccion}-${row.dia_proyeccion}: ` : 'N/A'}
                                        {row.fuente === "PROYECCION CONTEOS" ? dateFormatConDiaShort(row.fecha_proyeccion) : ''}
                                    </td>
                                    <td>{row.grados_dias_acumulado}</td>
                                    <td>{row.grados_dias_necesarios}</td>
                                    <td>{row.grados_dias_faltantes}</td>
                                    <td>{row.dias_diferencia}</td>
                                    <td>{row.extemporaneo}</td>
                                    <td>{row.ciclo_trasplante &&
                                        <>
                                            {dateFormatConDiaShort(row.ciclo_trasplante)} - {dateFormatConDiaShort(row.ciclo_cosecha)}
                                        </>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default TablaRegistrosProyeccion;